import { trackEvent } from "../api/fontApi";

export const trackOnboardingStep = async (onboardingStep) =>
  trackEvent(onboardingStep, "onboarding-step");

export const trackOnboardingPageView = async (pageViewData) =>
  trackEvent(pageViewData, "custom-onboarding-page-view");
